import React from "react";
import { connect } from "react-redux";
import { setSelectedMenu } from "../../Redux/Actions/actions";
import "./loading/report.css";
// mui
import { Stack, Typography, Box } from "@mui/material";
// icons
import { MdOutlineSupportAgent } from "react-icons/md";
import {
  TbUserBolt,
  TbCalendar,
  TbCalendarBolt,
  TbPhoneOutgoing,
  TbMessageCog,
  TbChartInfographic,
  TbShieldStar,
  TbChartHistogram,
  TbPhone,
  TbPhoneIncoming,
  TbSpeakerphone,
  TbChartArea,
  TbCalendarMonth,
  TbUserPentagon,
  TbClockShield,
  TbBrandWhatsapp,
} from "react-icons/tb";
import { BsStopwatch } from "react-icons/bs";
import { CgPerformance } from "react-icons/cg";
import { SlGraph } from "react-icons/sl";
import { ArrowsLeftRight } from "@phosphor-icons/react";
import { SiBaremetrics } from "react-icons/si";
import { SlNotebook } from "react-icons/sl";
import { FaWhatsappSquare } from "react-icons/fa";
import { GrDocumentPerformance } from "react-icons/gr";
// icons end

const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
  };
};

const ReportMenu = (props) => {
  let permission = JSON.parse(localStorage.getItem("permission")) || [];
  return (
    // reports start here
    <div className="card Report-card w-100 border-0  p-2 overflow-hidden">
      <div
        className="card-body box-inset overflow-hidden pb-0"
        style={{
          background: "#f3f6fc",
        }}
      >
        <div
          className="card-header bg-transparent px-0 pt-0 overflow-hidden"
          style={{ borderBottom: "1px solid #e0e4ef" }}
        >
          <Stack>
            <Typography
              className="fw-bold fs-16"
              sx={{
                textShadow: "rgba(194, 194, 194, 0.49) 1px 0px 0px",
                color: "rgb(11, 51, 99)",
              }}
            >
              Reports
            </Typography>
          </Stack>
        </div>
        <div className="h-100 reports">
          <div className="report-main row row-cols-4 row-cols-lg-4 pt-3 g-2 row-cols-sm-1 row-cols-md-2">
            {/* InteractionDetailsreports */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "INTERACTION_DETAILED_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("InteractionDetailsreports");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbMessageCog />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Interaction Details Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Customer interactions details report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>

                    </>
                  );
                }
              }
            })}

            {/* Agentskillsetreports */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "AGENT_SKILLSET_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("Agentskillsetreports");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <MdOutlineSupportAgent />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Agent Skillset Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of agent skillset report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* Servicereport */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "SERVICE_LEVEL_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("Servicereport");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbChartInfographic />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Service Level Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of service level report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* Outbounddetailedreport */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "OUTBOUND_DETAILED_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("Outbounddetailedreport");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbChartHistogram />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Outbound Detailed Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of outbound detailed report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>

                    </>
                  );
                }
              }
            })}

            {/* Skillsetsummary */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "SKILLSET_SUMMARY_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("Skillsetsummary");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbShieldStar />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Skillset Summary
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of skillset summary.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* Outboundsummaryreport */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "OUTBOUND_SUMMARY_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("Outboundsummaryreport");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbPhoneOutgoing />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Outbound Summary Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of outbound summary report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* Weeklyreport */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "WEEKLY_WISE_PERFORMANCE_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("Weeklyreport");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbCalendarMonth />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Weekly Wise Performance Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Weekly performance summary.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* Monthlyreport */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "MONTHLY_WISE_PERFORMANCE_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("Monthlyreport");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbCalendar />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Monthly Wise Performance Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Monthly performance summary.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* Yearlyreport */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "YEARLY_WISE_PERFORMANCE_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("Yearlyreport");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbCalendarBolt />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Yearly Wise Performance Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Yearly performance summary.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* Quaterlyreport */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "QUARTERLY_WISE_PERFORMANCE_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("Quaterlyreport");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbClockShield />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Quarterly Wise Performance Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Quarterly performance summary.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* Agentloginlogout */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "AGENT_LOGIN_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("Agentloginlogout");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <ArrowsLeftRight />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Agent Login Logout
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Agent login/logout report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* Agentstatusreport */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "AGENT_STATUS_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("Agentstatusreport");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbUserBolt />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Agent Status Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of agent status report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* AgentReports */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "AGENT_REPORT" && item.read && item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("AgentReports");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbUserPentagon />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Agent Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of agent report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* AgentStatisticsReport */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "AGENT_STAT_REPORT" && item.read && item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("AgentStatisticsReport");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbUserPentagon />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Agent Statistics Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of agent statistics report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* CampaignReport */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "CAMPAIGN_DETAILS_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("CampaignReport");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbChartArea />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Campaign Details Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of campaign details report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* CallbackReport */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "CALLBACK_DETAILS_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("CallbackReport");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbPhoneIncoming />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Callback Details Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of callback details report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* CampaignSummary */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "CAMPAIGN_SUMMARY_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("CampaignSummary");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbSpeakerphone />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Campaign Summary Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of campaign performance.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* CallbackSummary */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "CALLBACK_SUMMARY_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("CallbackSummary");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbPhone />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Callback Summary Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of callback activity.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>
                    </>
                  );
                }
              }
            })}

            {/* SessionReport */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "SESSION_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("SessionReport");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <BsStopwatch />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Session Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of Session activity.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>

                    </>
                  );
                }
              }
            })}

            {/* Agent Performance Report */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "AGENT_PERFORMANCE_METRICS" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("AgentPerformance");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <CgPerformance />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Agent Performance Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of Agent Performance Report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>

                    </>
                  );
                }
              }
            })}

            {/* Agent Metrics Report */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "AGENT_METRICS" && item.read && item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("AgentMatrix");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <SlGraph />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Agent Metrics Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of Agent Metrics Report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>

                    </>
                  );
                }
              }
            })}

            {/* Average Across All Chats Report */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "AVERAGE_ACROSS_ALL_CHATS" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("AverageAcrossChats");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <SiBaremetrics />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Average Across All Chats Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of Average Across All Chats Report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>

                    </>
                  );
                }
              }
            })}

            {/* whatsapp chat report */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "WHATSAPP_CHAT_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("WhatsappChat");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <TbBrandWhatsapp />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                WhatsApp Chat Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of WhatsApp Chat Report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>

                    </>
                  );
                }
              }
            })}

            {/* whatsapp chat report */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "WHATSAPP_OUTBOUND_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("WhatsappoutboundReport");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <FaWhatsappSquare />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                WhatsApp Outbound Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of WhatsApp Outbound Report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>

                    </>
                  );
                }
              }
            })}

            {/* Disposition report */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "DISPOSITION_CODE_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("DispositionCode");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <SlNotebook />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Disposition Code Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of disposition details report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>

                    </>
                  );
                }
              }
            })}

            {/* Inbound and outbound performance report */}
            {permission.map((module) => {
              if (module.moduleName === "REPORT") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "CONSOLIDATED_REPORT" &&
                    item.read &&
                    item.write
                );

                if (value) {
                  return (
                    <div className="col">
                      <div
                        className="card"
                        onClick={() => {
                          props.setSelectedMenu("inboundOutboundPerformance");
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack className="report-icon">
                            <Box
                              sx={{
                                fontSize: "2rem",
                                marginBottom: ".5rem",
                              }}
                            >
                              <GrDocumentPerformance />
                            </Box>
                          </Stack>
                          <Stack>
                            <Box className="report-hed">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                }}
                              >
                                Consolidated Report
                              </Typography>
                            </Box>
                            <Box
                              className="report-content"
                              item
                              md
                              zeroMinWidth
                            >
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "11px",
                                  lineHeight: "1rem",
                                  fontWeight: "400",
                                }}
                              >
                                Summary of Consolidated Report.
                              </Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <>

                    </>
                  );
                }
              }
            })}

          </div>
        </div>
      </div>
    </div>
    // reports end here
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
})(ReportMenu);
